import Wave from "src/images/wave.svg";
import theme from "src/styles/theme";
import { createGlobalStyle, keyframes } from "styled-components";

const waveAnimation = keyframes`
  from {
    background-position: 0 bottom;
  }
  to {
    background-position: 20px bottom;
  }
`;

const GlobalStyle = createGlobalStyle`
  :root {
    --clr-white: #FFF;
    --clr-black: #000;
    --clr-black-lighter: #333333;
    --clr-yellow: #FCCD3C;
    --clr-yellow-dark: #FCC723;
    --clr-purple: #A385FF;
    --clr-purple-dark: #906BFF;
    --clr-purple-accent: #470BFF;
    --clr-green: #20C997;
    --clr-green-dark: #1CB386;
    --clr-light-green: #85B239;
    --clr-turquoise: #00E4BE;
    --clr-pink: #FC2E8C;
    --clr-orange: #F16D2C;
    --clr-blue: #27AFF1;
    --clr-red: #FF7272;
    --clr-grey: #C4C4C4;
    --clr-grey-dark: #DEE2E6;
    --clr-grey-light: #F8F9FA;

    --fs-xxxs: 0.778rem;
    --fs-xxs: 0.889rem;
    --fs-base: 18px;
    --fs-xs: 1.111rem;
    --fs-s: 1.333rem;
    --fs-m: 1.555rem;
    --fs-l: 1.778rem;
    --fs-xl: 2.667rem;
    --fs-xxl: 3.556rem;
    --fs-xxxl: 4rem;

    --lh-xxs: 0.889rem;
    --lh-xs: 1.333rem;
    --lh-s: 1.778rem;
    --lh-m: 2.222rem;
    --lh-l: 2.667rem;
    --lh-xl: 3.556rem;

    --fw-normal: 400;
    --fw-bold: 600;
    --fw-bolder: 700;
    --fw-black: 900;

    --border-color: var(--clr-black);
    --border-thin: 2px;
    --border-thick: 4px;

    --nav-height: 64px;
    --nav-padding: 24px;

    --user-deck-height:124px;

    --page-max-width: 1600px;
    --page-padding: 96px;

    @media (max-width: 1024px) {
      --nav-height: 40px;
      --nav-padding: 16px;
      --page-padding: 16px;
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    font-size: var(--fs-base, 18px);
    font-family: 'sofia-pro';
  }

  body {
    overflow-x: hidden;
  }

  body,
  p,
  h1,
  h2,
  h3,
  h4,
  ul {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    outline: none;
  }

  video {
    display: block;
    width: 100%;
    outline: none;
  }

  h1 {
    font-size: var(--fs-xl);
    line-height: var(--lh-l);
  }

  h2 {
    font-size: var(--fs-l);
    line-height: var(--lh-m);

    @media (max-width: 768px) {
      font-size: var(--fs-s);
    }
  }

  h3 {
    font-size: var(--fs-s);
  }

  h4 {
    font-weight: var(--fw-black);
  }

  h1,
  h2,
  h3 {
    font-weight: var(--fw-bolder);
  }

  h3,
  h4 {
    line-height: var(--lh-s);
  }

  p {
    font-size: var(--fs-base);
    font-weight: var(--fw-normal);
    line-height: var(--lh-s);
  }

  button, textarea{
    font-family: 'sofia-pro';
  }

  .text-link {
    color: ${theme.colors.link};
    background-image: none;
    background-position: 0 bottom;
    padding-bottom: 3px;
    background-repeat: repeat-x;
    background-size: 20px 5px;
    animation: ${waveAnimation} 0.5s linear infinite;
    transition: all 0.3s ease-in-out;

    &:hover {
      background-image: url(${Wave});
    }
  }

  .text-underlined {
    background-image: linear-gradient(var(--clr-black), var(--clr-black));
    background-size: 100% 0;
    background-position: 0 100%;
    background-repeat: no-repeat;

    &:hover {
      transition: background-size 150ms;
      background-size: 100% 2px;
    }
  }
`;

export default GlobalStyle;
